

function EventableArea(props){
    return(
        <>
            {props.children}
        </>
    )
}

EventableArea.displayedName = 'EventableArea'

export default EventableArea